export const SITES_VIEW_PREFERENCE_KEY = "sites:view:preference";

export const SITES_VIEW = {
  LEGACY: "legacy",
  NEW: "new",
} as const;

export type SitesViewPreference =
  (typeof SITES_VIEW)[keyof typeof SITES_VIEW];

const DEFAULT_SITES_VIEW: SitesViewPreference = SITES_VIEW.NEW;

export const getSitesViewPreference = (
  isSuperUser = true,
): SitesViewPreference => {
  const preference = localStorage.getItem(SITES_VIEW_PREFERENCE_KEY);

  if (preference === SITES_VIEW.LEGACY || preference === SITES_VIEW.NEW) {
    return preference;
  }

  return isSuperUser ? DEFAULT_SITES_VIEW : SITES_VIEW.LEGACY;
};

export const setSitesViewPreference = (value: SitesViewPreference): void => {
  localStorage.setItem(SITES_VIEW_PREFERENCE_KEY, value);
};

export const getSitesViewPath = (
  value?: SitesViewPreference,
  isSuperUser = true,
): string => {
  const preference = value ?? getSitesViewPreference(isSuperUser);
  return preference === SITES_VIEW.LEGACY
    ? "/admin/sites-legacy"
    : "/admin/sites";
};
